module.exports = __webpack_public_path__ + "img/BZ.b76fcd7d.svg";